import React from 'react'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'
import PrimarySection from './Section/Primary'
import TranslationSection from './Section/Translation'
import AddressSection from './Section/Address'

const PoiDetails = props =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={3}>
      <Grid size={12}><FormHeader /></Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[3]} activeStep={0} orientation="vertical">
          <Step> <PrimarySection {...props} /> </Step>
          <Step> <TranslationSection {...props} /> </Step>
          <Step> <AddressSection {...props} /> </Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(PoiDetails)
